import { createStore } from 'vuex'
import theme from './modules/theme'
import viewport from './modules/viewport'
import chat from './modules/chat/chat'
import user from './modules/user'
import app from './modules/app'
import testprep from './modules/testprep/testprep'
import study from './modules/study/study'
import apexam from './modules/apexam/apexam'
import menu from './modules/menu'
import video from './modules/video/video'
import blog from './modules/blog/index'

export interface RootState {}

export default createStore<RootState>({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        theme,
        viewport,
        chat,
        user,
        app,
        testprep,
        study,
        apexam,
        menu,
        video,
        blog
    }
})
